<template>
    <div class="container layout">
        <top title="Maaş Bilgisi Karşılaştırmak İster misin?" desc="Hadi Maaş Anketine Katıl!" :PrivacyAccordion="true">
        </top>
        <div class="columns is-marginless">
            <div class="column is-7">
                <div class="column is-full">
                    <div>
                        <privacy-accordion class="is-hidden-tablet"></privacy-accordion>
                    </div>
                    <div class="box form salary-form">
                        <section>
                            <b-field label="Hangi işin için paylaşıyorsun?*">
                                <b-field>
                                    <b-radio-button v-model="currentJob" type="is-info" :native-value="true">
                                        <span>Mevcut İşim</span>
                                    </b-radio-button>

                                    <b-radio-button v-model="currentJob" type="is-info" :native-value="false">
                                        <span>Önceki İşim</span>
                                    </b-radio-button>
                                </b-field>
                            </b-field>

                            <b-field label="Hangi şirket için paylaşıyorsun?">
                                <b-autocomplete ref="companyAutocomplete" v-model="company.name" :data="company.data"
                                    placeholder="Şirket Ara" field="companyName" :loading="company.isFetching"
                                    @input="getAutoCompleteService('company')" @select="option => company.selected = option"
                                    :open-on-focus="true" icon-pack="mdi" icon="magnify">
                                </b-autocomplete>
                            </b-field>

                            <b-field label="Hangi pozisyon için paylaşıyorsun?*"
                                :type="{ 'is-danger': !position.selected && !valid }"
                                :message="{ 'Bir pozisyon seçmelisin': !position.selected && !valid }">
                                <b-autocomplete ref="positionAutocomplete" v-model="position.name" :data="position.data"
                                    placeholder="Pozisyon Ara" field="name" :loading="position.isFetching"
                                    @input="getAutoCompleteService('position')"
                                    @select="option => position.selected = option" :open-on-focus="true" icon-pack="mdi"
                                    icon="magnify">
                                </b-autocomplete>
                            </b-field>

                            <b-field label="Aldığın maaş net mi brüt mü?" :type="{ 'is-danger': !salaryTypeId && !valid }"
                                :message="{ 'Maaş tipi seçmelisin': !salaryTypeId && !valid }">
                                <b-field>
                                    <b-radio-button v-model="salaryTypeId" type="is-info" native-value="Net">

                                        <span>Net</span>
                                    </b-radio-button>

                                    <b-radio-button v-model="salaryTypeId" type="is-info" native-value="Brut">
                                        <span>Brüt</span>
                                    </b-radio-button>
                                </b-field>
                            </b-field>

                            <b-field
                                :label="currentJob ? 'Aylık ne kadar maaş alıyorsun?' : 'Aylık ne kadar maaş alıyordun?'"
                                :type="price.length < 4 && !valid ? 'is-danger' : parseInt(price) > onChangeSalaryType ? 'is-danger' : ''"
                                :message="price.length < 4 && !valid ? 'Geçerli bir maaş bilgisi girmelisin' : parseInt(price) > onChangeSalaryType ?  'Maksimum ' + onChangeSalaryType + ' TL girebilirsin.' : ''">
                                <b-field
                                    :type="price.length < 4 && !valid ? 'is-danger' : parseInt(price) > onChangeSalaryType ? 'is-danger' : ''">
                                    <b-input type="text" v-mask="'######'" placeholder="Ör: 2500" inputmode="numeric"
                                        pattern="[0-9]*" v-model="price" class="salary-price"></b-input>
                                    <p class="control salary-price-currency">
                                        <span class="button is-static">TL</span>
                                    </p>
                                </b-field>
                            </b-field>


                            <b-field :label="currentJob ? 'Yılda kaç maaş alıyorsun?*' : 'Yılda kaç maaş alıyordun?*'">
                                <b-select placeholder="Seçiniz" v-model="salaryCount">
                                    <option :value="item" v-for="(item, index) in salaryCountOptions" :key="index">
                                        <template v-if="item !== 17">{{ item }} Maaş</template>
                                        <template v-else>{{ item }} Maaş veya üstü</template>
                                    </option>
                                </b-select>
                            </b-field>

                            <b-field label="Son maaşını ne zaman aldın?*" v-if="!currentJob"
                                :type="{ 'is-danger': !leaveDateText && !valid }"
                                :message="{ 'Son maaş aldığın yılı seçmelisin': !leaveDateText && !valid }">
                                <b-field class="salary-last-addons">
                                    <b-radio-button v-for="(year, index) in leaveDateArr" v-model="leaveDateText"
                                        type="is-info" :key="index" :native-value="year">
                                        <span>{{ year }}</span>
                                    </b-radio-button>
                                </b-field>
                            </b-field>

                            <b-field label="Nerede yaşıyorsun?*" :type="{ 'is-danger': !city.selected && !valid }"
                                :message="{ 'Bir şehir seçmelisin': !city.selected && !valid }">
                                <b-autocomplete ref="cityAutocomplete" v-model="city.name" :data="city.data"
                                    placeholder="Şehir Ara" field="name" :loading="city.isFetching"
                                    @input="getAutoCompleteService('city')" @select="option => city.selected = option"
                                    :open-on-focus="true" icon-pack="mdi" icon="magnify">
                                </b-autocomplete>
                            </b-field>

                            <b-field label="Çalışma şeklin nasıl?*" :type="{ 'is-danger': !workType && !valid }"
                                :message="{ 'Çalışma şekli seçmelisin': !workType && !valid }">
                                <b-select placeholder="Çalışma Şeklini Seç" v-model="workType" required>
                                    <option value="3">Uzaktan</option>
                                    <option value="2">Hibrit</option>
                                    <option value="1">Ofis</option>
                                </b-select>
                            </b-field>

                            <div class="recaptcha">
                                <recaptcha type="salary" :valid="reCaptchaValid"
                                    @verify="reCaptchaValue = $event, checkReCaptcha()"></recaptcha>
                            </div>

                            <div class="buttons is-centered">
                                <button class="button is-primary is-uppercase has-text-weight-semibold salary-save"
                                    :class="isLoading ? 'is-loading' : ''" @click="addSalary" :disabled="isLoading">Onayla ve
                                    Paylaş</button>
                            </div>

                        </section>

                    </div>
                </div>
            </div>
            <div class="column is-hidden-mobile">
                <privacy-accordion></privacy-accordion>
            </div>
        </div>
    </div>
</template>
<script>

import { mask } from 'vue-the-mask'

import apiConfigs from '@/services/config'
import autocomplete from '@/mixins/autocomplete'

import top from '@/components/Top'
import PrivacyAccordion from '@/components/PrivacyAccordion'
import recaptcha from "@/components/Recaptcha"


export default {
    name: 'Salary',
    components: { PrivacyAccordion, top, recaptcha },
    mixins: [autocomplete],
    data() {
        return {
            valid: true,
            currentJob: true,
            salaryTypeId: 'Net',
            salaryCount: 12,
            price: '',
            leaveDateText: null,
            leaveDate: null,
            isLoading: false,
            reCaptchaValue: null,
            reCaptchaValid: true,
            workType: sessionStorage.getItem('workType'),

        }
    },
    directives: { mask },
    computed: {
        salaryCountOptions() {
            return Array(6).fill().map((_, i) => 12 + i);
        },
        leaveDateArr() {
            return Array(4).fill().map((_, i) => new Date().getFullYear() - i).sort();
        },
        onChangeSalaryType() {
            let lmt = null
            if (this.salaryTypeId === 'Net') {
                lmt = 250000;
            }
            else {
                lmt = 435000;
            }
            return lmt
        },
    },
    methods: {
        formValid(params) {
            let formKeys = ['positionId', 'salaryTypeId', 'price', 'salaryCount', 'workType'],
                formElementValid = {},
                valid
            // add leaveDate control
            if (!this.currentJob) formKeys.push('leaveDate')

            // form valid  control
            formKeys.map(item => formElementValid[item] = Object.keys(params).indexOf(item))
            valid = !Object.values(formElementValid).includes(-1)

            return valid
        },
        addSalary: function () {

            let params = {};

            if (this.company.selected) {
                params.companyId = this.company.selected.companyId;
                params.companyName = this.company.selected.companyName;
            }

            if (this.position.selected) {
                params.positionId = this.position.selected.id;
            }

            //add cityId and workType from sessionstorage to params
            params.cityId = sessionStorage.getItem('cityId');
            params.workType = sessionStorage.getItem('workType');

            if (this.salaryCount) params.salaryCount = this.salaryCount;
            if(this.price.length >= 4) {
                if (parseInt(this.price) <= this.onChangeSalaryType) {
                    params.price = this.price;
                }
            }

            if (this.salaryTypeId) params.salaryTypeId = this.salaryTypeId;
            if (this.leaveDateText) {
                params.leaveDate = new Date('01.01.' + this.leaveDateText.toString() + ' 03:00');
            }

            this.valid = this.formValid(params);

            this.checkReCaptcha();

            if (!this.valid) {
                // scroll top is danger
                this.$nextTick(() => {
                    document.querySelectorAll('.is-danger')[0].scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" })
                });
                return false
            }

            this.isLoading = true;

            apiConfigs.serviceWrapper(apiConfigs.serviceConfigs.salary, apiConfigs.serviceConfigs.salary.add, params, { CKEY: this.reCaptchaValue.key })
                .then((response) => {
                    let data = response.data;
                    if (data.statusCode === 200) {

                        // set company, position information
                        sessionStorage.setItem('userCompany', JSON.stringify(this.company.selected))
                        sessionStorage.setItem('userPosition', JSON.stringify(this.position.selected))

                        // salary complete
                        this.$router.push({ name: 'Complete', params: { type: 'salary' } })
                    }
                    this.isLoading = false;
                })

                .catch(() => {
                    this.isLoading = false;
                })
        },
        checkReCaptcha() {
            if (!this.reCaptchaValue || (!this.reCaptchaValue.key && this.reCaptchaValue.enabled)) {
                this.reCaptchaValid = false;
                this.valid = false;
            }
            else
                this.reCaptchaValid = true
        }
    },
    created() {
        if (sessionStorage && sessionStorage.currentJob) {
            this.currentJob = JSON.parse(sessionStorage.currentJob)
            sessionStorage.removeItem('currentJob')
        }
    }
}
</script>
